var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({staticClass:"button",attrs:{"data-testid":"ContinuarButton"},on:{"click":_vm.handleClick}},'v-btn',Object.assign({}, _vm.$props, _vm.$attrs),false),[_c('span',{staticClass:"text"},[_vm._v(" Imprimir")])])}
var staticRenderFns = []

export { render, staticRenderFns }